<div class="sports-grid-content-single">
  <p class="sports-grid-content-single--title color-dark">{{ title | sportsTitleCase:countryCode }}</p>
  <p class="sports-grid-content-single--subtitle color-muted" *ngIf="subtitle">{{ subtitle | sportsTitleCase }}</p>
</div>
 